import { LogLevel, OpenIdConfiguration } from "angular-auth-oidc-client";

// export const environment = {
//   production: false,
//   companyName: 'Concrete',
//   merchantLimit: 500,
//   apiRoot: 'https://localhost:44397',
//   recipeApiRoot: '',
//   mapRoutingServiceUrl: 'https://localhost:5000/route/v1',
//   lang: 'pl',
//   apiDateFormat: 'YYYY-MM-DD HH:mm:ss',
//   displayDateFormat: 'DD-MM-YYYY',
//   reportsUrl: '',
//   identityConfig: {
//     stsServer: 'https://concrete.identity.devitmcode.pl',
//     redirectUrl: 'http://localhost:4200/#/authorised/dashboard',
//     clientId: 'concrete_client',
//     responseType: 'code',
//     scope: 'openid profile offline_access IdentityServerApi ConcreteApi',
//     postLogoutRedirectUri: 'http://localhost:4200/#/authorised/dashboard',
//     silentRenew: true,
//     silentRenewUrl: `${window.location.origin}/assets/silent-renew.html`,
//     renewTimeBeforeTokenExpiresInSeconds: 15,
//     postLoginRoute: '/home',
//     forbiddenRoute: '/forbidden',
//     unauthorizedRoute: '/unauthorized',
//     logLevel: LogLevel.Error,
//     useRefreshToken: true,
//   } as OpenIdConfiguration,
// };

export const environment = {
  production: false,
  companyName: 'Concrete',
  merchantLimit: 500,
  apiRoot: 'https://concrete.api.devitmcode.pl',
  recipeApiRoot: '',
  mapRoutingServiceUrl: 'https://localhost:5000/route/v1',
  lang: 'pl',
  apiDateFormat: 'YYYY-MM-DD HH:mm:ss',
  displayDateFormat: 'DD-MM-YYYY',
  reportsUrl: '',
  identityConfig: {
    stsServer: 'https://concrete.identity.devitmcode.pl',
    redirectUrl: 'https://concrete.devitmcode.pl/#/authorised/dashboard',
    clientId: 'concrete_client',
    responseType: 'code',
    scope: 'openid profile offline_access IdentityServerApi ConcreteApi',
    postLogoutRedirectUri: 'http://concrete.devitmcode.pl/#/authorised/dashboard',
    silentRenew: true,
    silentRenewUrl: `${window.location.origin}/assets/silent-renew.html`,
    renewTimeBeforeTokenExpiresInSeconds: 15,
    postLoginRoute: '/home',
    forbiddenRoute: '/forbidden',
    unauthorizedRoute: '/unauthorized',
    logLevel: LogLevel.Error,
    useRefreshToken: true,
  } as OpenIdConfiguration,
};